import { render, staticRenderFns } from "./QuestionDetailModal.vue?vue&type=template&id=bf0f612a"
import script from "./QuestionDetailModal.vue?vue&type=script&lang=js"
export * from "./QuestionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionDetailModal.vue?vue&type=style&index=0&id=bf0f612a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports